import React from "react";
import { FaFacebook, FaPhone, FaWhatsapp } from "react-icons/fa";
import { SOCIAL_LINKS } from "../../constants/site";

const ICONS = {
  facebook: FaFacebook,
  whatsapp: FaWhatsapp,
  phone: FaPhone,
};

function HeroSocialLinks({ isRtl }) {
  return (
    <div className="hero-bottom-bar absolute inset-x-0 bottom-0 z-10 hidden md:block" dir="ltr">
      <div
        className={`mx-auto flex max-w-7xl items-center px-4 pb-5 pt-2 sm:px-6 sm:pb-6 ${
          isRtl ? "flex-row-reverse justify-between" : "justify-between"
        }`}
      >
        <p className="hero-scroll-hint pointer-events-none">
          {isRtl ? "مرر لأسفل" : "Scroll"}
        </p>

        <div className="pointer-events-auto">
          <div className="hero-social-bar flex items-center gap-0.5 rounded-full px-2 py-1.5 sm:gap-1 sm:px-2.5">
            {SOCIAL_LINKS.map(({ id, href, external }) => {
              const Icon = ICONS[id];
              return (
                <a
                  key={id}
                  href={href}
                  target={external ? "_blank" : undefined}
                  rel={external ? "noopener noreferrer" : undefined}
                  aria-label={id}
                  className="hero-social-link"
                >
                  <Icon className="h-[17px] w-[17px] sm:h-[18px] sm:w-[18px]" />
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeroSocialLinks;
